<template>
  <div>
    <span :title="mediumTooltipContent">{{ listing.medium.title }}</span>
  </div>
</template>

<script>
export default {
  name: "Listing.Medium",
  props: {
    listing: {
      type: Object,
      required: true,
      default: {},
    },
  },
  computed: {
    mediumTooltipContent() {
      return (
        (this.listing.medium.title === "Mixed Media" && this.listing.medium.description) || this.listing.medium.title
      )
    },
  },
}
</script>
